import {
  HEADER_MAIN_MENU,
  HEADER_SOCIAL_MENU,
  HEADER_TOP_MOBILE_MENU,
} from "@header/HeaderMenuConstants";
import { HeaderMenuList } from "@header/HeaderMenuList";
import MySphLoginButton from "@header/TopHeader/MySPHLoginButton";
import UserInfo from "@header/TopHeader/UserInfo/UserInfo";
import { isProd } from "@helper/utils";
import useUserInfo from "@hooks/useUserInfo";
import { ReactElement } from "react";
import { Link } from "react-router";

export type HamburgerMenuModalProps = {
  expandMenu: boolean;
  onClick: () => void;
};

export function HamburgerMenuModal({
  expandMenu,
}: HamburgerMenuModalProps): ReactElement {
  const { userInfo } = useUserInfo();
  return (
    <>
      {expandMenu ? (
        <div className="lg:hidden relative font-primary xs:border-t xs:border-solid xs:border-gray-600 lg:border-none overflow-y-scroll bg-white-100 max-h-[90vh]">
          <div className="pb-6 pt-sm px-xs">
            <Link
              reloadDocument
              className="w-full h-xl inline-block text-center rounded-lg bg-100 text-white-100 pt-2 tracking-widest font-bold"
              to="https://subscribe.sph.com.sg/publications-tm/?utm_campaign=tm_subscription&utm_medium=sph-publication&utm_source=tm&utm_content=subscribebutton-header"
            >
              சந்தா
            </Link>
          </div>
          <div className="px-sm">
            {!isProd && (
              <>
                {userInfo?.loginId ? (
                  <UserInfo loginId={userInfo.loginId} />
                ) : (
                  <MySphLoginButton />
                )}
              </>
            )}
            <HeaderMenuList
              testId="mobile-top-links"
              items={HEADER_TOP_MOBILE_MENU}
              type="top-mobile"
              isHamburger={true}
            />
            <HeaderMenuList
              testId="mobile-main-links"
              items={HEADER_MAIN_MENU}
              type="main"
              isHamburger={true}
            />
          </div>
          <div className="text-center">
            <HeaderMenuList
              testId="mobile-social-links"
              items={HEADER_SOCIAL_MENU}
              type="social"
              isHamburger={true}
            />
          </div>
        </div>
      ) : null}
    </>
  );
}
